import { gql } from "graphql-tag";

export const createMutualFollowCodeGQL = gql`
  mutation Mutation {
    createMutualFollowCode {
      oncode
    }
  }
`;
